import { Chip } from '@mui/material';


function GroupLabel({ name }) {
    return <Chip size="small" variant="outlined" label={name} />
}

export default GroupLabel;